import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { alpha, useTheme } from "@mui/material/styles";
import ExploreOffOutlinedIcon from "@mui/icons-material/ExploreOffOutlined";
import EmptyState from "../Design/EmptyState";
import { useSurfaces } from "../../theme/surfaces";
import { radius } from "../../theme/tokens";

/**
 * The 404 screen. Same message as before, rebuilt on the shared state
 * treatment so it follows the palette instead of hardcoding black text.
 */
const NotFound = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const s = useSurfaces();

  return (
    <Box sx={{ display: "grid", placeItems: "center", py: { xs: 4, md: 8 } }}>
      <Box
        sx={{
          ...s.card,
          borderRadius: `${radius.xl}px`,
          maxWidth: 520,
          width: "100%",
          px: 3,
          pt: 4,
        }}
      >
        <Typography
          aria-hidden
          sx={{
            textAlign: "center",
            fontSize: 56,
            fontWeight: 750,
            lineHeight: 1,
            letterSpacing: "-0.04em",
            color: alpha(theme.palette.primary.main, 0.22),
          }}
        >
          404
        </Typography>

        <EmptyState
          icon={<ExploreOffOutlinedIcon />}
          title="Page not found"
          description="The page you are looking for does not exist, or it may have been moved."
          action={
            <Box sx={{ display: "flex", gap: 1.25, flexWrap: "wrap", justifyContent: "center" }}>
              <Button variant="outlined" onClick={() => navigate(-1)}>
                Go back
              </Button>
              <Button variant="contained" onClick={() => navigate("/dashboard")}>
                Go to dashboard
              </Button>
            </Box>
          }
        />
      </Box>
    </Box>
  );
};

export default NotFound;
